import { useState } from "react";
import { noRecordsAlert } from "../../../../../../_helpers/Helpers";
import { PersonnelUsersUIProvider } from "./PersonnelUsersUIContext";
import { PersonnelUsersCard } from "./PersonnelUsersCard";
import { IPListEdit } from "../IP-list-edit/IPListEdit";

export function PersonnelUsersPage() {
  const [ids, setIds] = useState();
  const [showIPListEdit, setShowIPListEdit] = useState();
  const closeIPListEdit = () => setShowIPListEdit(false);

  const personnelUsersUIEvents = {
    openIPListEditModal: (ids) => {
      if (typeof ids === 'string') ids = ids.split(",");
          
      if (ids.length < 1) {
        noRecordsAlert();
        return;
      }
      setIds(ids);
      setShowIPListEdit(true);
    }
  };

  return (
    <PersonnelUsersUIProvider personnelUsersUIEvents={personnelUsersUIEvents}>
      <IPListEdit
        ids={ids}
        showIPListEdit={showIPListEdit}
        closeIPListEdit={closeIPListEdit}
      />
      <PersonnelUsersCard />
    </PersonnelUsersUIProvider>
 );
}